import React from "react";

function Phone(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1120"
      height="1981.333"
      version="1"
      viewBox="0 0 840 1486"
      className={props.class}
    >
      <path
        id={props.id}
        d="M1506 14434c-566-88-1034-465-1215-978-18-50-42-131-54-180l-22-91V1955l22-91c71-291 200-522 403-724 243-240 584-401 935-440 58-6 1004-10 2635-10 2190 0 2559 2 2649 15 536 76 961 374 1186 830 69 140 103 245 129 394 15 86 16 585 16 5640 0 6044 4 5611-55 5816-34 118-118 291-197 407-73 109-231 272-338 350-156 114-345 206-523 253-216 58-64 55-2887 54-2157-1-2610-3-2684-15zm3823-893c103-53 97-182-9-225-36-14-150-16-1121-16-1181 0-1119-3-1172 59-50 60-28 143 48 181 39 20 61 20 1128 20 1057 0 1089-1 1126-19zm2137-1438c53-28 100-83 113-130 14-51 15-8713 1-8763-13-47-63-106-113-133l-42-22H984l-49 25c-65 33-111 100-120 173-3 28-5 2001-3 4382l3 4330 22 42c26 48 76 89 130 109 32 11 584 13 3248 11l3210-2 41-22zM4378 2540c289-80 490-325 509-619 13-207-66-403-222-549-404-377-1069-135-1145 417-29 213 41 413 200 571 141 141 279 198 480 199 76 1 125-5 178-19z"
        transform="matrix(.1 0 0 -.1 0 1486)"
      ></path>
    </svg>
  );
}

export default Phone;
